import {
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import { useState } from "react";
import SearchBar from "../../components/SearchBar";
import SwitchToggle from "../../components/SwitchToggle";
import React from "react";

const ManageCarAccessories = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");

  const [rows] = useState([
    {
      id: 1,
      accessoryName: "Steering Wheel Cover",
      accessoryImage: "/static/images/placeholder.png",
      dealerName: "John Motors",
      dealerPhone: "9876543210",
      dealerImage: "/static/images/placeholder.png",
      actualPrice: "€6,500",
      discountedPrice: "€5,000",
      createdDate: "01-Sept-2025",
      status: true,
    },
    {
      id: 2,
      accessoryName: "Car Air Freshener & Perfume",
      accessoryImage: "/static/images/placeholder.png",
      dealerName: "Auto Hub",
      dealerPhone: "9876501234",
      dealerImage: "/static/images/placeholder.png",
      actualPrice: "€6,500",
      discountedPrice: "€5,000",
      createdDate: "05-Sept-2025",
      status: false,
    },
  ]);

  return (
    <>
      <div className="main_title">
        <h1>Listed Car Accessories</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> – Listed Car Accessories
        </p>
      </div>

      <div className="cards">
        <div className="table_header">
          <div className="left_s">
            <SearchBar
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setSearchTerm}
              placeholder="Search car accessory..."
            />
          </div>
          <div className="right_s">
            <Button
              className="btn btn_primary"
              onClick={() => navigate("/manage-car-accessories/add")}
            >
              <AddIcon /> Add Car Accessory
            </Button>
          </div>
        </div>

        <TableContainer className="table_container">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Car Accessory Detail</TableCell>
                <TableCell>Dealer Detail</TableCell>
                <TableCell>Price</TableCell>
                <TableCell>Created Date</TableCell>
                <TableCell>Enable/Disable</TableCell>
                <TableCell>Featured</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {rows.map((row, index) => (
                <TableRow hover key={row.id}>
                  {/* Car Accessory Detail */}
                  <TableCell>
                    <div className="user_block">
                      <figure className="no_radius">
                        <img src={row.accessoryImage} alt={row.accessoryName} />
                      </figure>
                      <div>
                        <p>
                          <b>{row.accessoryName}</b>
                        </p>
                      </div>
                    </div>
                  </TableCell>

                  {/* Dealer Detail */}
                  <TableCell>
                    <a
                      href="/manage-dealers/detail"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate("/manage-dealers/detail");
                      }}
                      className="user_block click_action"
                    >
                      <p>
                        <b>{row.dealerName}</b>
                        <span>{row.dealerPhone}</span>
                      </p>
                    </a>
                  </TableCell>

                  {/* Price */}
                  <TableCell>
                    <strong className="c_primary">{row.discountedPrice}</strong>{" "}
                    <del>{row.actualPrice}</del>
                  </TableCell>

                  <TableCell>{row.createdDate}</TableCell>

                  <TableCell>
                    <SwitchToggle defaultChecked={row.status} />
                  </TableCell>

                  <TableCell>
                    <SwitchToggle />
                  </TableCell>

                  <TableCell>
                    <div className="table_actions v2">
                      <IconButton
                        onClick={() => navigate("/manage-car-accessories/detail")}
                      >
                        <img src="/static/images/eye_icon.svg" alt="View" />
                      </IconButton>

                      <IconButton
                        onClick={() => navigate("/manage-car-accessories/edit")}
                      >
                        <img src="/static/images/edit2_icon.svg" alt="Edit" />
                      </IconButton>

                      <IconButton>
                        <img src="/static/images/trash2_icon.svg" alt="Delete" />
                      </IconButton>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </>
  );
};

export default ManageCarAccessories;